module.exports = __webpack_public_path__ + "img/1.1d2c6bec.png";